import { AxiosInstance } from 'axios'
import { IExportResponse } from '../../../types/importExport.types'

export function questionsExportApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/export/content'

  const methods = {
    getAll() {
      return api.get<IExportResponse[]>(`${baseUrl}`)
    },
    getExport(exportId: number) {
      return api.get<IExportResponse>(`${baseUrl}/${exportId}`)
    },
    triggerExport(anonymised: boolean) {
      return api.post<IExportResponse>(`${baseUrl}?anonymised=${anonymised}`, {})
    },
    async getDownloadLink(exportId: number, filename: string): Promise<HTMLAnchorElement | undefined> {
      return api.get(`${baseUrl}/${exportId}/file`, {
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([ response.data ], { type: 'application/zip' })
        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(blob)
        downloadLink.download = filename
        return downloadLink
      })
    }
  }
  return methods
}
